import { makeStyles } from "@material-ui/core"

import { colors } from "@/styles/colors"
import ColorUtil from "@/utils/ColorUtil"

const useStyles = makeStyles(theme => ({
	sheetPaper: {
		borderRadius: "1.625rem 1.625rem 0 0",
		backgroundColor: colors.gray[0],
		padding: "0.625rem 0 1.125rem",
		overflowY: "auto"
	},
	dragHandle: {
		width: "2.75rem",
		height: "0.25rem",
		borderRadius: "0.125rem",
		backgroundColor: colors.gray[200],
		margin: "0 auto 0.875rem"
	},
	moreLabel: {
		fontSize: theme.typography.pxToRem(17),
		fontWeight: 700,
		color: colors.gray[800],
		padding: "0 1.375rem",
		marginBottom: "1.25rem"
	},
	menuItem: {
		padding: "0 1.375rem",
		cursor: "pointer",
		minHeight: "3rem"
	},
	menuItemIcon: {
		color: colors.gray[800],
		display: "flex",
		alignItems: "center",
		marginRight: "1rem"
	},
	menuItemLabel: {
		fontSize: theme.typography.pxToRem(17),
		fontWeight: 400,
		color: colors.gray[800]
	},
	scrimBackground: {
		backgroundColor: ColorUtil.hexToRgba(colors.gray[800], 0.45)
	},
	profileDivider: {
		margin: "1.125rem 1.375rem",
		backgroundColor: colors.gray[200],
		height: "0.0625rem",
		border: "none"
	},
	profileRow: {
		padding: "0 1.375rem",
		minHeight: "3.5rem"
	},
	profileAvatar: {
		width: "2.5rem",
		height: "2.5rem",
		borderRadius: "50%",
		backgroundColor: colors.gray[0],
		border: `1px solid ${colors.purple[100]}`,
		marginRight: "0.75rem"
	},
	profileAvatarIcon: {
		color: colors.purple[600]
	},
	profileTextContainer: {
		flex: 1
	},
	profileName: {
		fontSize: theme.typography.pxToRem(15),
		fontWeight: 600,
		color: colors.gray[800],
		marginBottom: "0.125rem",
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap"
	},
	profileEmail: {
		fontSize: theme.typography.pxToRem(13),
		color: colors.gray[500],
		overflow: "hidden",
		textOverflow: "ellipsis",
		whiteSpace: "nowrap"
	},
	profileChevron: {
		color: colors.purple[100]
	},
	subSheetHeader: {
		minHeight: "3rem",
		marginBottom: "0.875rem",
		padding: "0 1.375rem"
	},
	subSheetTitle: {
		fontSize: theme.typography.pxToRem(17),
		fontWeight: 600,
		color: colors.gray[800]
	}
}))

export default useStyles
